<div class="toaster" aria-live="polite" aria-atomic="false">
  @for (toast of toasts.$toasts | async; track toast.id) {
    <div class="toast toast--{{ toast.kind }}" [class.toast--leaving]="toast.leaving" role="status"
      (click)="toasts.dismiss(toast.id)">
      <i class="toast__icon {{ icons[toast.kind] }}" aria-hidden="true"></i>
      <div class="toast__body">
        <span class="toast__message">{{ toast.message }}</span>
        @if (toast.description) { <span class="toast__description">{{ toast.description }}</span> }
      </div>
    </div>
  }
</div>
